(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-topbar-message"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-topbar-message]").forEach((topbar) => {

      const btn = topbar.querySelector("[data-btn-close]");

      btn?.addEventListener("click", () => {
        topbar.style.display = "none";
      });

    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-secondary-banner"] && !Shopify.designMode) return;
  try {
    
  const transitionDuration = 800;

  function initBannerSliders(scope = document) {
    const sliders = scope.querySelectorAll('.banner-swiper');

    sliders.forEach((slider) => {
      if (slider.sliderInterval) {
        clearInterval(slider.sliderInterval);
        slider.sliderInterval = null;
      }

      const track = slider.querySelector('.banner-track');

      if (!track) return;

      const originalSlides = [...track.querySelectorAll('.banner-slide')];

      if (originalSlides.length <= 1) return;

      const pagination = slider.querySelector('.banner-pagination');

      pagination.innerHTML = '';

      track.querySelectorAll('.clone').forEach((el) => el.remove());

      const firstClone = originalSlides[0].cloneNode(true);

      firstClone.classList.add('clone');

      track.appendChild(firstClone);

      let currentIndex = 0;

      originalSlides.forEach((_, index) => {
        const dot = document.createElement('button');

        dot.classList.add('banner-dot');

        if (index === 0) {
          dot.classList.add('active');
        }

        dot.addEventListener('click', () => {
          currentIndex = index;

          updateSlider();

          restartInterval();
        });

        pagination.appendChild(dot);
      });

      const dots = pagination.querySelectorAll('.banner-dot');

      function updateDots(index) {
        dots.forEach((dot) => dot.classList.remove('active'));

        dots[index].classList.add('active');
      }

      function goToSlide(index, animated = true) {
        track.style.transition = animated ? `transform ${transitionDuration}ms cubic-bezier(0.22, 1, 0.36, 1)` : 'none';

        track.style.transform = `translateX(-${index * 100}%)`;
      }

      function updateSlider(animated = true) {
        goToSlide(currentIndex, animated);

        updateDots(currentIndex);
      }

      function startInterval() {
        slider.sliderInterval = setInterval(() => {
          currentIndex++;

          goToSlide(currentIndex);

          if (currentIndex === originalSlides.length) {
            updateDots(0);

            setTimeout(() => {
              currentIndex = 0;

              goToSlide(currentIndex, false);
            }, transitionDuration + 50);
          } else {
            updateDots(currentIndex);
          }
        }, 4000);
      }

      function restartInterval() {
        clearInterval(slider.sliderInterval);

        startInterval();
      }

      updateSlider(false);

      startInterval();
    });
  }

  initBannerSliders();

  document.addEventListener('shopify:section:load', (event) => {
    initBannerSliders(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
